import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kHTMLCore } from "../../../Admin/kReusableCoreTS/kHTMLCore";
import { AppContact } from "./AppIndex";
import { AppIcons } from "./AppIcons";
import { AppChatListRules } from "./AppChatListRules";

// AppChatQuickView - THE "⋯" BESIDE EACH CHAT IN THE LIST: it opens that chat's "Chat settings" dialog
// (`AppChatSettingsDialog` - archive, notifications, disappearing messages, the star, translation) without opening the
// chat. Pure markup: list rendering is also imported by the node-only Bridge.
// ⚠ Until 2026-10-13 it opened a small dialog of its own with one state line per setting ("Archive status unknown").
// The button says what it opens and carries no state.

export class AppChatQuickView {
    public static readonly Attr: string = "data-chat-more";

    public static Button = (One: AppContact): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (One.ChatId.length === 0) { return ""; }
            if (One.IsGroup === true && AppChatListRules.IdOk(One.ChatId) === false) { return ""; }
            const Name: string = kHTMLCore.EscapeAttr("Chat settings for " + One.Title);
            return "<button type=\"button\" class=\"btn ghost icon sm chatquick-open\" " + AppChatQuickView.Attr + "=\""
                + kHTMLCore.EscapeAttr(One.ChatId) + "\" aria-haspopup=\"dialog\" aria-label=\"" + Name
                + "\" title=\"" + Name + "\">" + AppIcons.Svg(AppIcons.More, 18) + "</button>";
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatQuickView.Button"); return ""; }
    };
}
